<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    layout: WebLayout,
}
</script>
<script setup>
import { computed } from 'vue'
import SEOHead from '@/components/SEOHead.vue'
import { useWebTranslations } from '@/composables/useWebTranslations.js'

const { get, locale, webRoute, alternateLocales } = useWebTranslations()
const contactUrl = computed(() => `${webRoute('web.home')}#contact`)
const seoTitle = computed(() => `${get('about_us.title')} - Growiyo`)
const seoDescription = computed(() => get('about_us.meta_description'))
const canonicalPath = computed(() => webRoute('web.about-us'))
const pageAlternateLocales = computed(() => alternateLocales('web.about-us'))
</script>

<template>
    <SEOHead
        :title="seoTitle"
        :description="seoDescription"
        :keywords="get('about_us.meta_keywords')"
        :canonical="canonicalPath"
        :locale="locale"
    :alternate-locales="pageAlternateLocales"
        :structured-data="{
            '@type': 'WebSite',
            'name': 'Growiyo.com',
            'url': 'https://growiyo.com',
            'description': seoDescription,
        }"
        type="website"
    />
    <div class="container mx-auto px-4 py-12 lg:py-20">
        <div class="max-w-4xl mx-auto">
            <h1 class="text-4xl md:text-5xl font-bold text-growiyo-dark mb-10 text-center">
                {{ get('about_us.title') }}
            </h1>

            <section class="space-y-10 text-growiyo-dark/90">
                <p class="text-lg leading-relaxed">
                    {{ get('about_us.intro') }}
                </p>

                <div class="rounded-2xl bg-growiyo-light/60 p-6 lg:p-8 border border-growiyo-dark/5">
                    <p class="text-growiyo-dark/85 leading-relaxed">
                        {{ get('about_us.who_we_are_for') }}
                    </p>
                </div>

                <div>
                    <h2 class="text-2xl font-bold text-growiyo-dark mb-4">
                        {{ get('about_us.what_we_offer_title') }}
                    </h2>
                    <p class="leading-relaxed">
                        {{ get('about_us.what_we_offer') }}
                    </p>
                </div>

                <p class="leading-relaxed">
                    {{ get('about_us.start_selling') }}
                </p>

                <div class="rounded-2xl growiyo-gradient-bg p-6 lg:p-8 text-center">
                    <p class="text-white/95 text-lg font-medium mb-6">
                        {{ get('about_us.cta') }}
                    </p>
                    <a
                        :href="contactUrl"
                        class="inline-flex items-center justify-center px-8 py-4 bg-growiyo-dark text-white font-semibold rounded-lg hover:bg-growiyo-dark/90 transition-colors"
                    >
                        {{ get('footer.contact_us') }}
                    </a>
                </div>
            </section>
        </div>
    </div>
</template>
